import React, { useState, useEffect, useCallback } from "react";
import { ResellerPageStyle } from "./Reseller.styled";
import TopBar from "../../components/TopBar/TopBar";
import { useLocation } from "react-router-dom";
import { HeadingStyle } from "../../styles/HeadingStyles";
import Footer from "../../components/footer/Footer";
import Table from "../../components/Table/Table";
import Button from "react-bootstrap/Button";
import Color from "../../common/ColorEnum";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { saveAs } from "file-saver";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { useDB } from "../../context/DynamoDBContext";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getResellerBaseStationStatus,
  getResellerBaseStationStatus2,
  getResellerBaseStationStatus3,
  getSubscriptionsStatus,
  getResellerBeaconStatus,
  getResellerBeaconStatus2,
} from "../../api/ResellerApi";
import { getSubscriptionPlanList } from "../../api/CouponApi";
import { toast } from "react-toastify";
import { getSubscriptionString } from "../../common/ConvertSubscription";

const ViewReseller = () => {
  const location = useLocation();
  const title = location.state?.title;
  const dummydata = [
    {
      id: "J37H32939S93",
      status: "Active",
      email: "ocufii@gmail.com",
      accountCreationDate: "01-12-2023",
      subStatus: "ACTIVE",
      plan: "Standard Notification Monthly",
      subscriptionStart: "01-12-2023",
      subscriptionEnd: "31-12-2023 09:44",
      promoCode: "",
    },
    {
      id: "DH37HDNKJBAH",
      status: "InActive",
      email: "johndoe@gmail.com",
      accountCreationDate: "07-08-2023",
      subStatus: "EXPIRED",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "L147HHH4EV76",
      status: "Active",
      email: "test@gmail.com",
      accountCreationDate: "11-10-2023",
      subStatus: "ACTIVE",
      plan: "Group Notification Monthly",
      subscriptionStart: "07-08-2023",
      subscriptionEnd: "07-07-2023",
      promoCode: "J27H992L",
    },
    {
      id: "BW5TF23CF78G",
      status: "Active",
      email: "test2@gmail.com",
      accountCreationDate: "23-08-2023",
      subStatus: "ACTIVE",
      plan: "Group Notification Monthly",
      subscriptionStart: "23-08-2023",
      subscriptionEnd: "23-09-2023",
      promoCode: "",
    },
    {
      id: "O9HGFR08VDS2",
      status: "InActive",
      email: "test3@gmail.com",
      accountCreationDate: "31-04-2023",
      subStatus: "EXPIRED",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "LG64VDS27HB4",
      status: "InActive",
      email: "test4@gmail.com",
      accountCreationDate: "16-07-2023",
      subStatus: "EXPIRED",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "NH98FR4DSR7T",
      status: "InActive",
      email: "",
      accountCreationDate: "",
      subStatus: "",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "LO08GDE32DR6",
      status: "InActive",
      email: "",
      accountCreationDate: "",
      subStatus: "",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "KJ567FE2SVCT",
      status: "InActive",
      email: "",
      accountCreationDate: "",
      subStatus: "",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "MJG6543JGD4D",
      status: "InActive",
      email: "",
      accountCreationDate: "",
      subStatus: "",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
    {
      id: "NBFDE5THU3DR",
      status: "InActive",
      email: "",
      accountCreationDate: "",
      subStatus: "",
      plan: "",
      subscriptionStart: "",
      subscriptionEnd: "",
      promoCode: "",
    },
  ];
  const { dynamoDBClient } = useDB();
  const [beacons, setBeacons] = useState([]);
  const [baseStation, setBaseStation] = useState([]);
  const [enableApi, setEnableApi] = useState(false);
  const doc = new jsPDF();
  const [baseStationLoading, setBaseStationLoading] = useState(false);
  const [beaconLoading, setBeaconLoading] = useState(false);
  const [enableBSAPI2, setEnableBSAPI2] = useState(false);
  const [enableBSAPI3, setEnableBSAPI3] = useState(false);
  const [enableBSAPI4, setEnableBSAPI4] = useState(false);
  const queryClient = useQueryClient();
  const [enableBeaconAPI1, setEnableBeaconAPI1] = useState(false);
  const [enableBeaconAPI2, setEnableBeaconAPI2] = useState(false);
  const [enableBeaconAPI3, setEnableBeaconAPI3] = useState(false);
  const [enableSubscriptionPlan, setEnableSubscriptionPlan] = useState(false);
  const [activeBaseStations, setActiveBaseStations] = useState(0);
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
  const [activeBeacons, setActiveBeacons] = useState(0);
  const [subscriptions, setSubscriptions] = useState({
    total: 0,
    arr: [],
  });

  const [visited, setVisited] = useState([]);

  useEffect(() => {
    //   if (dynamoDBClient !== null) {
    //     setBeacons([]);
    //     setBaseStation([]);
    //     setEnableApi(false);
    //     setEnableBeaconAPI1(false);
    //     setBaseStationLoading(false);
    //     setBeaconLoading(false);
    //     setEnableBSAPI2(false);
    //     setEnableBSAPI3(false);
    //     setEnableBSAPI4(false);
    //     setEnableBeaconAPI2(false);
    //     setEnableBeaconAPI3(false);
    //     setActiveBaseStations(0);
    //     setActiveBeacons(0);
    //     setSubscriptions({
    //       total: 0,
    //       nsm: 0,
    //       nsy: 0,
    //       gnm: 0,
    //       gny: 0,
    //     });
    //     setVisited([]);
    //   }

    if (dynamoDBClient !== null) {
      setBaseStationLoading(true);
      setBeaconLoading(true);
      setEnableApi(true);
      setEnableBeaconAPI1(true);
      setEnableSubscriptionPlan(true);
    }
  }, [dynamoDBClient]);

  const { data: subscriptionList } = useQuery({
    queryKey: ["getSubscriptionPlanList"],
    queryFn: () => getSubscriptionPlanList(dynamoDBClient),
    enabled: enableSubscriptionPlan,
    onSuccess: (data) => {
      if (data.length != 0) {
        setSubscriptionPlanList(data);
      }
      setEnableSubscriptionPlan(false);
    },
    onError: (error) => {
      toast.error("Unable to get Subscription List", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    },
  });

  const checkSubscriptionIos = (data) => {
    if (data.subStatus !== "PROMO_EXPIRED" && data.subStatus !== "EXPIRED") {
      setSubscriptions((item) => ({
        ...item,
        total: item.total + 1,
        arr: [...item.arr, data.plan],
      }));

      if (data.subType === "notice_service_monthly") {
        setSubscriptions((item) => ({ ...item, nsm: item.nsm + 1 }));
      }

      if (data.subType === "notice_service_yearly") {
        setSubscriptions((item) => ({ ...item, nsy: item.nsy + 1 }));
      }

      if (data.subType === "group_notice_service_monthly") {
        setSubscriptions((item) => ({ ...item, gnm: item.gnm + 1 }));
      }

      if (data.subType === "group_notice_service_yearly") {
        setSubscriptions((item) => ({ ...item, gny: item.gny + 1 }));
      }
    }
  };

  const checkSubscriptionAndroid = (data) => {
    if (
      data.subStatus !== "SUBSCRIPTION_STATE_EXPIRED" &&
      data.subStatus !== "SUBSCRIPTION_STATE_PROMO_EXPIRED"
    ) {
      setSubscriptions((item) => ({
        ...item,
        total: item.total + 1,
        arr: [...item.arr, data.plan],
      }));
      if (data.subId === "notice_service") {
        if (data.subType === "P1M") {
          // monthly notification
          setSubscriptions((item) => ({ ...item, nsm: item.nsm + 1 }));
        } else {
          // yearly notification
          setSubscriptions((item) => ({ ...item, nsy: item.nsy + 1 }));
        }
      } else {
        if (data.subType === "P1M") {
          // monthly group notification
          setSubscriptions((item) => ({ ...item, gnm: item.gnm + 1 }));
        } else {
          // yearly group notification
          setSubscriptions((item) => ({ ...item, gny: item.gny + 1 }));
        }
      }
    }
  };

  const countSubscriptions2 = (data, check) => {
    if (data?.subId) {
      // subscription is android
      if (
        data.subId !== check[0].subStatus &&
        data.subType !== check[0].subType
      ) {
        checkSubscriptionAndroid(data);
      }
    } else {
      //subscription is ios
      if (data.subType !== check[0].subType) {
        checkSubscriptionIos(data);
      }
    }
  };

  const countSubscriptions = useCallback((data) => {
    const check = visited.filter((item) => item.email === data.email);

    if (check.length > 0) {
      countSubscriptions2(data, check);
    } else {
      setVisited((prev) => {
        const check2 = prev.filter((item) => item.email === data.email);
        if (check2.length > 0) {
          countSubscriptions2(data, check2);
        } else {
          if (data?.subId) {
            // subscription is android
            checkSubscriptionAndroid(data);
          } else {
            // subscription is ios
            checkSubscriptionIos(data);
          }
          return [...prev, data];
        }

        return prev;
      });
    }
  });

  const countAccount = (data) => {
    data.forEach((element) => {
      setVisited((prev) => {
        const check = prev.filter((item) => item?.email === element?.email);
        if (check.length === 0) {
          if (element?.email) {
            return [...prev, element];
          }
        }
        return prev;
      });
    });
  };

  const { status: baseStationStatus, data: baseStationData } = useQuery({
    queryKey: ["ShowTotalResellerBaseStation", title],
    queryFn: () => getResellerBaseStationStatus(dynamoDBClient, title),
    enabled: enableApi,
    onSuccess: (response) => {
      const data = response.baseStationList;

      const check = response.check;
      if (check) {
        setEnableApi(false);
        setEnableBSAPI2(true);
        queryClient.fetchQuery(["ShowTotalResellerBaseStation2", title], {
          queryFn: () => getResellerBaseStationStatus2(dynamoDBClient, data),
        });
      } else {
        setBaseStation(data);
        setBaseStationLoading(false);
      }
    },
  });

  const { data: baseStation2 } = useQuery({
    queryKey: ["ShowTotalResellerBaseStation2", title],
    queryFn: () =>
      getResellerBaseStationStatus2(
        dynamoDBClient,
        baseStationData.baseStationList
      ),
    enabled: enableBSAPI2,
    onSuccess: (response) => {
      const data = response.arr;
      const check = response.check;
      if (check) {
        setEnableBSAPI2(false);
        setEnableBSAPI3(true);
        queryClient.fetchQuery(["ShowTotalResellerBaseStation3", title], {
          queryFn: () => getResellerBaseStationStatus3(dynamoDBClient, data),
        });
      } else {
        setEnableBSAPI2(false);
        setBaseStation(data);
        setBaseStationLoading(false);
      }
    },
  });

  const { data: baseStation3 } = useQuery({
    queryKey: ["ShowTotalResellerBaseStation3", title],
    queryFn: () =>
      getResellerBaseStationStatus3(dynamoDBClient, baseStation2.arr),
    enabled: enableBSAPI3,
    onSuccess: (data = []) => {
      setEnableBSAPI3(false);
      setEnableBSAPI4(true);
      queryClient.fetchQuery(["ShowTotalResellerBaseStation4", title], {
        queryFn: () => getSubscriptionsStatus(dynamoDBClient, data),
      });
    },
  });
  const { data: baseStation4 } = useQuery({
    queryKey: ["ShowTotalResellerBaseStation4", title],
    queryFn: () => getSubscriptionsStatus(dynamoDBClient, baseStation3),
    enabled: enableBSAPI4,
    onSuccess: (data = []) => {
      setBaseStation(data);
      setBaseStationLoading(false);
      setEnableBSAPI4(false);
      let noActiveAccount = true;
      const count = data.reduce((acc, obj) => {
        const isActive = obj.status === "Active";
        if (isActive) {
          noActiveAccount = false;
          countSubscriptions(obj);
        }

        return acc + (isActive ? 1 : 0);
      }, 0);
      if (noActiveAccount) {
        countAccount(data);
      }
      setActiveBaseStations(count);
    },
  });

  const { status: beaconStatus, data: beaconData } = useQuery({
    queryKey: ["showTotalResellerBeacon", title],
    queryFn: () => getResellerBeaconStatus(dynamoDBClient, title),
    enabled: enableBeaconAPI1,
    onSuccess: (response) => {
      const data = response.beaconList;
      const check = response.check;
      if (check) {
        setEnableBeaconAPI1(false);
        setEnableBeaconAPI2(true);
        queryClient.fetchQuery(["showTotalResellerBeacon2", title], {
          queryFn: () => getResellerBeaconStatus2(dynamoDBClient, data),
        });
      } else {
        setBeaconLoading(false);
        setBeacons(data);
        setEnableBeaconAPI1(false);
      }
    },
  });

  const { data: beaconData2 } = useQuery({
    queryKey: ["showTotalResellerBeacon2", title],
    queryFn: () =>
      getResellerBeaconStatus2(dynamoDBClient, beaconData.beaconList),
    enabled: enableBeaconAPI2,
    onSuccess: (response) => {
      const data = response.arr;

      const check = response.check;
      if (check) {
        setEnableBeaconAPI3(true);
        queryClient.fetchQuery(["showTotalResellerBeacon3", title], {
          queryFn: () => getSubscriptionsStatus(dynamoDBClient, data),
        });
      } else {
        setEnableBeaconAPI2(false);
        setBeaconLoading(false);
        setBeacons(data);
      }
    },
  });

  const { data: beaconData3 } = useQuery({
    queryKey: ["showTotalResellerBeacon3", title],
    queryFn: () => getSubscriptionsStatus(dynamoDBClient, beaconData2.arr),
    enabled: enableBeaconAPI3,
    onSuccess: (data = []) => {
      setBeacons(data);
      setBeaconLoading(false);
      setEnableBeaconAPI3(false);
      let noActiveAccount = true;
      const count = data.reduce((acc, obj) => {
        const isActive = obj.status === "Active";
        if (isActive) {
          noActiveAccount = false;
          countSubscriptions(obj);
        }
        return acc + (isActive ? 1 : 0);
      }, 0);
      if (noActiveAccount) {
        countAccount(data);
      }
      setActiveBeacons(count);
    },
  });

  const downloadpdf = () => {
    doc
      .text("Ocufii Admin Portal Reseller Report", 100, 10, { align: "center" })
      .setFontSize(12)
      .setFont("Helvetica", "bold");
    doc
      .text(`ResellerID: ${title}`, 100, 20, { align: "center" })
      .setFontSize(12)
      .setFont("Helvetica", "bold");
    doc.setFontSize(10);
    doc.setFont("Helvetica", "bold");
    doc
      .text(`Total Accounts: ${visited.length}`, 31, 30, { align: "center" })
      .setFontSize(10)
      .setFont("Helvetica", "bold");
    doc
      .text(`Total Active Subscriptions: ${subscriptions.total}`, 40, 40, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "normal");
    doc
      .text(`Standard Notification Monthly: ${subscriptions.nsm}`, 47, 50, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "normal");
    doc
      .text(`Standard Notification Yearly: ${subscriptions.nsy}`, 46, 60, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "normal");
    doc
      .text(`Group Notification Monthly: ${subscriptions.gnm}`, 45, 70, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "normal");
    doc
      .text(`Group Notification Yearly: ${subscriptions.gny}`, 44, 80, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "bold");
    doc
      .text(`Total Active Base Stations: ${activeBaseStations}`, 40, 90, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "bold");
    doc
      .text(`Total Active Beacons: ${activeBeacons}`, 36, 100, {
        align: "center",
      })
      .setFontSize(10)
      .setFont("Helvetica", "bold");

    const data = [];
    baseStation.forEach((element, index) => {
      data.push([
        index + 1,
        element.id,
        element.status,
        element.email,
        element.activationTime,
        element.subStatus,
        element.plan,
      ]);
    });
    const data2 = [];
    beacons.forEach((element, index) => {
      data2.push([
        index + 1,
        element.id,
        element.status,
        element.email,
        element.activationTime,
        element.subStatus,
        element.plan,
      ]);
    });

    autoTable(doc, { html: "#my-table" });
    autoTable(doc, {
      head: [
        [
          "#",
          "GatewayMAC",
          "Status",
          "Email",
          "First Activation Time",
          "Subscription Status",
          "Subscription Type",
        ],
      ],
      body: data,
      startY: 110,
      columnStyles: { text: { cellWidth: "auto" } },
    });
    autoTable(doc, {
      head: [
        [
          "#",
          "BeaconMAC",
          "Status",
          "Email",
          "First Activation Time",
          "Subscription Status",
          "Subscription Type",
        ],
      ],
      body: data2,
    });

    doc.save("Ocufii Reseller Report.pdf");
  };
  return (
    <ResellerPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>ResellerID: {title}</HeadingStyle>
        <div className="download-div3">
          <Button
            variant="secondary"
            style={{ backgroundColor: Color.orange, borderColor: Color.orange }}
            onClick={() => downloadpdf()}
            disabled={beaconLoading || baseStationLoading}
          >
            Download Report
          </Button>
        </div>
        {/* Details */}
        <div className="detail-main">
          <div className="details-div">
            <p className="detail-heading">Total Accounts:&ensp;</p>
            <p>{visited.length}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Total Active Subscriptions:&ensp;</p>
            <p>{subscriptions.total}</p>
          </div>
          {subscriptionPlanList.map((item, index) => {
            const monthly = subscriptions.arr.reduce((count, sub) => {
              return (
                count +
                (sub === `${getSubscriptionString(item.SubscriptionId)} Monthly`
                  ? 1
                  : 0)
              );
            }, 0);
            const yearly = subscriptions.arr.reduce((count, sub) => {
              return (
                count +
                (sub === `${getSubscriptionString(item.SubscriptionId)} Yearly`
                  ? 1
                  : 0)
              );
            }, 0);

            return (
              <div key={index}>
                <div className="details-div2">
                  <p className="detail-heading2">
                    {getSubscriptionString(item.SubscriptionId)} Monthly:&ensp;
                  </p>
                  <p>{monthly}</p>
                </div>
                <div className="details-div2">
                  <p className="detail-heading2">
                    {getSubscriptionString(item.SubscriptionId)} Yearly:&ensp;
                  </p>
                  <p>{yearly}</p>
                </div>
              </div>
            );
          })}

          {/* <div className="details-div2">
            <p className="detail-heading2">Group Notification Monthly:&ensp;</p>
            <p>{subscriptions.gnm}</p>
          </div>
          <div className="details-div2">
            <p className="detail-heading2">Group Notification Yearly:&ensp;</p>
            <p>{subscriptions.gny}</p>
          </div> */}
          <div className="details-div">
            <p className="detail-heading">Total Active Base Stations:&ensp;</p>
            <p>{activeBaseStations}</p>
          </div>
          <div className="details-div">
            <p className="detail-heading">Total Active Beacons:&ensp;</p>
            <p>{activeBeacons}</p>
          </div>
        </div>
        {/* Tables */}
        <HeadingStyle>
          Base Stations&ensp;
          <i className="bi bi-clipboard2-data heading-icon" />
        </HeadingStyle>
        <div className="table-container3">
          <Table
            tableName={"GatewayMAC"}
            status={baseStationLoading}
            data={baseStation}
          />
        </div>
        <div className="space-reseller" />
        <HeadingStyle>
          Beacons&ensp;
          <i className="bi bi-clipboard2-data heading-icon" />
        </HeadingStyle>
        <div className="table-container3">
          <Table
            tableName={"BeaconMAC"}
            status={beaconLoading}
            data={beacons}
          />
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </ResellerPageStyle>
  );
};

export default ViewReseller;
